/** @file Route definitions for the login and registration pages. */
import { lazyLoadView } from '@/components/higher_order/LazyLoader';
import { getDefault, NO_STUDENT_VIEW } from '../utils';
/**
 * Returns a meta object for a route.
 *
 * @param obj The meta object to merge with the default meta.
 * @returns The merged meta object.
 */
function getMeta(obj) {
    return {
        loginRequired: false,
        hideSidebar: true,
        hideFooter: true,
        getStudentViewPage: NO_STUDENT_VIEW,
        ...obj,
    };
}
const loaderOpts = Object.freeze({ class: 'hidden!' });
export default [
    {
        path: '/login/one-time-password',
        name: 'login-otp-verification',
        component: lazyLoadView({
            getComponent: () => import('@/pages/Login/OTPAuthentication').then(getDefault),
            errorMessage: 'Could not load one-time password page',
            loaderOpts,
        }),
        meta: getMeta({ readableName: 'Login - One-time Password' }),
    },
    {
        path: '/login/select-tenant',
        name: 'login-tenant-list',
        component: lazyLoadView({
            getComponent: () => import('@/pages/Login/TenantList').then(getDefault),
            errorMessage: 'Could not load select tenant page',
        }),
        meta: getMeta({ readableName: 'Login - Select Tenant' }),
    },
    {
        path: '/login/select-account/:session',
        name: 'login-select-account',
        component: lazyLoadView({
            getComponent: () => import('@/pages/Login/SelectAccount').then(getDefault),
            errorMessage: 'Could not load select account page',
            loaderOpts,
        }),
        meta: getMeta({ readableName: 'Login - Select Account' }),
    },
    {
        path: '/login/:tenantId?',
        name: 'login',
        component: lazyLoadView({
            getComponent: () => import('@/pages/Login/Login').then(getDefault),
            errorMessage: 'Could not load login page.',
            loaderOpts,
        }),
        meta: getMeta({ readableName: 'Login' }),
    },
    {
        path: '/forgot/:tenantId?',
        name: 'forgot',
        component: lazyLoadView({
            getComponent: () => import('@/pages/Login/ForgotPassword').then(getDefault),
            errorMessage: 'Could not load forgot password page.',
            loaderOpts,
        }),
        meta: getMeta({ readableName: 'Forgot Password' }),
    },
    {
        path: '/tenants/:tenantId/users/:userId/reset_password',
        name: 'reset-password-new',
        component: lazyLoadView({
            getComponent: () => import('@/pages/Login/ResetPassword').then(getDefault),
            errorMessage: 'Could not load reset password page.',
            loaderOpts,
        }),
        meta: getMeta({ readableName: 'Reset Password' }),
    },
    {
        path: '/reset_password',
        name: 'reset-password',
        component: lazyLoadView({
            getComponent: () => import('@/pages/Login/ResetPassword').then(getDefault),
            errorMessage: 'Could not load reset password page.',
            loaderOpts,
        }),
        meta: getMeta({ readableName: 'Reset Password' }),
    },
    {
        path: '/register',
        name: 'register-start',
        component: lazyLoadView({
            getComponent: () => import('@/pages/Register/Start').then(getDefault),
            errorMessage: 'Could not load register page',
            loaderOpts,
        }),
        meta: getMeta({ readableName: 'Register Start' }),
    },
    {
        path: '/register/account-details/:token',
        name: 'register-account-details',
        component: lazyLoadView({
            getComponent: () => import('@/pages/Register/AccountDetails').then(getDefault),
            errorMessage: 'Could not load register account details page',
            loaderOpts,
        }),
        meta: getMeta({ readableName: 'Register Account Details' }),
    },
    // Pages where it just feels like an redirection.
    {
        path: '/login_and_redirect/:loginFile',
        name: 'login_and_redirect',
        component: lazyLoadView({
            getComponent: () => import('@/pages/LoginAndRedirect').then(getDefault),
            errorMessage: 'Could not load login and redirect page.',
        }),
        meta: getMeta({ readableName: 'Login and Redirect' }),
    },
    {
        path: '/sso_login/:blobId',
        name: 'sso_login',
        component: lazyLoadView({
            getComponent: () => import('@/pages/SsoLogin').then(getDefault),
            errorMessage: 'Could not load SSO login page.',
        }),
        meta: {
            loginRequired: false,
            hideSidebar: true,
            hideFooter: true,
            readableName: 'SSO Login',
            getStudentViewPage: NO_STUDENT_VIEW,
        },
    },
];
